<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<div class="header">
  <div class="logo header-content"></div>
  <ul class="user-actions header-content">
    <li>
      <a routerLink="/login" routerLinkActive="active">Sign in</a>
    </li>
  </ul>
</div>
<div class="nav">
  <ul class="nav-options">
    <li>Our Product</li>
    <li>Plans</li>
    <li>Help</li>
    <li>Contact</li>
  </ul>
</div>
<div class="container">
  <h2>Choose your plan and sign up in Four Easy Steps!</h2>
  <div class="plans row">
    <div class="col-md-4 col-sm-12">
      <div id="plan-a" class="plan-options">
        <div class="plan-bg">
          <h4>Plan-A</h4>
          <h1>&#8377; 7,999</h1>
        </div>
        <div class="plan-content">
          <ul>
            <li>1 Doctor</li>
            <li>25 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a routerLink="/register">Get Started</a>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div id="plan-b" class="plan-options">
        <div class="plan-bg">
          <h4>Plan-B</h4>
          <h1>&#8377; 21,999</h1>
        </div>
        <div class="plan-content">
          <ul>
            <li>3 Doctor</li>
            <li>75 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a routerLink="/register">Get Started</a>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div id="plan-c" class="plan-options">
        <div class="plan-bg">
          <h4>Plan-C</h4>
          <h1>&#8377; 34,999</h1>
        </div>
        <div class="plan-content">
          <ul>
            <li>Unlimited</li>
            <li>100 Patients</li>
            <li>Additional Info</li>
          </ul>
          <a href="../register">Get Started</a>
        </div>
      </div>
    </div>
  </div>
</div>
